import { fetchEndpointData } from '@utils/fetchEndpointData';

import type {
  CustomerPortalListApiKeysResponse,
  CustomerPortalCreateApiKeyResponse,
  CustomerPortalRevokeApiKeyResponse,
} from './endpoints/CustomerPortalApiKeyEndpoints.types';

export async function fetchCustomerPortalApiKeys(customerId: number) {
  return fetchEndpointData<CustomerPortalListApiKeysResponse>(`/api/customer-portal/api-keys?customerId=${customerId}`);
}

export async function createCustomerPortalApiKey(data: { customerId: number; name: string; scopes: string[] }) {
  return fetchEndpointData<CustomerPortalCreateApiKeyResponse>('/api/customer-portal/api-keys', {
    method: 'POST',
    body: data,
  });
}

export async function revokeCustomerPortalApiKey(id: string) {
  return fetchEndpointData<CustomerPortalRevokeApiKeyResponse>(`/api/customer-portal/api-keys/${id}`, {
    method: 'DELETE',
  });
}
